import React, { SetStateAction, useRef, useState } from "react";
import { Strings } from "../../../../utils/strings";
import { Form, FormControl } from "react-bootstrap";
import "./MobileEmailContent.css";
import * as EmailValidator from "email-validator";
import LoadingIndicator from "../../../loadingIndicator/LoadingIndicator";
import { WebChatApi } from "../../../../apis/webChat.api";

type props = {
  setIsOtpSent: React.Dispatch<React.SetStateAction<boolean>>;
  setEmail: React.Dispatch<React.SetStateAction<string | undefined>>;
  email: string | undefined;
};

export const MobileEmailContent: React.FC<props> = ({
  setIsOtpSent,
  setEmail,
  email,
}) => {
  const [isValid, setIsValid] = useState(true);
  const inputRef = useRef<HTMLInputElement>(null); // Create a ref for the input element
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleEmailChange = (event: {
    target: { value: SetStateAction<string | undefined> };
  }) => {
    let value = event.target?.value?.toString();
    setIsValid(true);
    setEmail(value);
    if (error) {
      setError("");
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default behavior (form submission)
      //   sendOTPCode(); // Call sendOTPCode when Enter key is pressed
    }
  };

  const sendOTPCode = async () => {
    if (email && EmailValidator.validate(email)) {
      try {
        setLoading(true);
        await WebChatApi.otpCodeSend({
          email: `${email}`,
        });
        setIsValid(true);
        setIsOtpSent(true);
        setLoading(false);
      } catch (error: any) {
        setLoading(false);
        setError(error.message);
      }
    } else {
      setIsValid(false);
      setError(Strings.PLEASE_ENTER_VALID_NUMBER);
    }
  };

  return (
    <div className="login-modal-container">
      <div className="login-modal-details-container">
        <span className="login-modal-title">{Strings.LOGIN}</span>
        <span className="login-modal-subtitle">{Strings.WELCOME}</span>
        <p className="login-modal-desc">
          {Strings.LOGIN_DESC}
          <span style={{ fontWeight: "600" }}>{Strings.JUST_ASK}</span>
        </p>
      </div>

      <div className="login-modal-input-container">
        <Form>
          <Form.Group controlId="formBasicEmail">
            <FormControl
              type="text"
              placeholder={Strings.EMAIL_ADDRESS}
              value={email}
              onChange={handleEmailChange}
              className="login-modal-input"
              isInvalid={!isValid}
              // isValid={sendClicked}
              ref={inputRef}
              onKeyDown={handleKeyPress}
              required
            />
          </Form.Group>
          {error && email && (
            <p
              style={{
                color: "red",
                fontSize: 13,
                textAlign: "center",
                marginTop: 5,
              }}>
              {error}
            </p>
          )}
        </Form>
        <button
          type="button"
          className="login-modal-sendOtpbtn"
          onClick={() => {
            sendOTPCode();
          }}>
          {Strings.SEND_OTP}
        </button>
      </div>

      <div className="login-modal-tc-container">
        <p className="login-modal-tc ">
          {Strings.LOGIN_TC}
          <a
            href="https://www.google.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#858383" }}>
            {Strings.TERMS_OF_SERVICE}
          </a>
        </p>
        <p className="login-modal-do-not-have-account">
          {Strings.DONT_HAVE_ACCOUNT}
          <a
            href="https://www.google.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#0A4D43", fontWeight: "600" }}>
            {Strings.SIGN_UP_HERE}
          </a>
        </p>
      </div>
      <LoadingIndicator className="login-modal-overlay" loading={loading} />
    </div>
  );
};
